export default __webpack_public_path__ + "static/media/fem_1.4d341094.png";